import superMeta from '../_CATEGORY_ROOT/metaCategoryRootNode.mjs'

export default {
    ...superMeta,
    name: '模型群',
    type: 'CAT_ROOT_PRJ_SLN',
}
